import state from './moduleRoutesState'
import mutations from './moduleRoutesMutations'
import actions from './moduleRoutesActions'
import getters from './moduleRoutesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
